module.exports = __webpack_public_path__ + "static/media/ps_timer_screen.661e4e0e.svg";